import { useEffect, useState } from "react";
import useAuthStore from "../../store/useAuthStore";
import { useProfileUpdateStore } from "../../store/useProfileUpdateStore";
import { useUserStore } from "../../store/useUserStore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Bio = () => {
  const { activeSection, setActiveSection, updateProfile } = useProfileUpdateStore();
  const authStore = useAuthStore.getState();
  const userId = authStore.user.id;
  const user = useUserStore((state) => state.user);
  const getUserDetails = useUserStore((state) => state.getUserDetails);

  const [bio, setBio] = useState(user?.know_about_you || "");
  const [errors, setErrors] = useState<{ bio?: string }>({});

  

  useEffect(() => {
    if (!user || user.id !== userId) {
      getUserDetails(userId);
    }
  }, [userId, user, getUserDetails]);

  if (activeSection !== "bio") return null;

 const validateForm = () => {
  const newErrors: { bio?: string } = {};
  if (!bio || bio.trim().length < 300) {
    newErrors.bio = "Bio must be at least 300 characters.";
  }
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

  const handleSave = async () => {
   
    if (!validateForm()) return;
  
    const updatedData = {
      bio: {
        bio,
      },
    };
  
    try {
      await updateProfile(userId, updatedData);
      getUserDetails(userId);
  
      toast.success("Bio updated successfully!");
       setActiveSection(null); // Uncomment to close
    } catch (error) {
      console.log(error);
      
      toast.error("Failed to update bio. Please try again.");
    }
  };

  return (
    <div className="card border mb-3 filter-container">
      <div className="border-bottom pb-4 mb-4 d-flex w-100 align-items-center gap-3">
        <h4 className="mb-0">My Bio</h4>
        <button
          type="button"
          className="btn_close_cross_btn ms-auto"
          onClick={() => setActiveSection(null)}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>

      <p className="mb-3">
        Writing about yourself can be challenging, so here are some ideas to spark inspiration.
      </p>

       <textarea
        className="form-control rounded-3 text-start font16 mb-3"
        rows={12}
        value={bio}
        onChange={(e) => {
          if (e.target.value.length <= 300) {
            setBio(e.target.value);
          }
        }}
        placeholder="Write something about yourself..."
      />

      <div className="d-flex justify-content-between align-items-center mb-2">
        <small
          className={`font-weight-bold ${
            bio.trim().length < 300 ? 'text-muted' : 'text-success'
          }`}
        >
          {`${bio.trim().length}/300 characters`}
        </small>
      </div>

    {errors.bio && <small className="text-danger">{errors.bio}</small>}

    <p className="mb-4 border-bottom pb-3">Maximum 300 characters</p>

      <button onClick={handleSave} className="btn btn-outline-primary w-100">
        Save Changes
      </button>
    </div>
  );
};

export default Bio;
